import { Skeleton } from '@/components/ui/skeleton';
import InsightCard from './InsightCard';

interface InsightCardListProps {
  data?: Array<{ title: string; body: string }>;
  isLoading?: boolean;
  showNumbers?: boolean;
  voiceQuotes?: Array<{ conversation_id: string; message_id?: string }>;
  fallbackQuestionId?: string;
}

function InsightCardList({
  data,
  isLoading = false,
  showNumbers = true,
  voiceQuotes,
  fallbackQuestionId,
}: InsightCardListProps) {
  if (isLoading) {
    return (
      <div className="space-y-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-lg border border-neutral-100 bg-neutral-50/50 p-4">
            <div className="flex gap-3">
              <Skeleton className="h-6 w-6 rounded-full shrink-0" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-48 rounded-sm" />
                <Skeleton className="h-4 w-full rounded-sm" />
                <Skeleton className="h-4 w-[80%] rounded-sm" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!data || data.length === 0) return null;

  return (
    <div className="space-y-3">
      {data.map((item, idx) => (
        // E4 / audit F-9: prefer the title (unique-enough per insight)
        // and fall back to title+idx when titles legitimately collide
        // (rare, e.g. test data). The previous index-only key caused
        // InsightCard's internal state (e.g. expanded body, copy
        // button "copied!" flash) to bleed across items when the data
        // array re-ordered after a filter / language switch.
        <InsightCard
          key={`${item.title || 'untitled'}-${idx}`}
          title={item.title}
          body={item.body}
          index={showNumbers ? idx + 1 : undefined}
          voiceQuotes={voiceQuotes}
          fallbackQuestionId={fallbackQuestionId}
        />
      ))}
    </div>
  );
}

export default InsightCardList;
